import {
  ENDPOINT_PROJECTS_ALL_CONTOURS,
  ENDPOINT_PROJECTS_LIST,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { create } from 'zustand';
import {
  IAllContour,
  IProjects,
  IProjectsById,
  TProjects,
} from '../models/IProject';
import { IParams } from '@/features/lands/models/ILands';
import { IPageable } from '@/common/models';
const httpApi = new HttpApi();
const useProjectStore = create<TProjects>((set) => ({
  projects: {} as IPageable<IProjects>,
  allContour: [],
  projectsById: {} as IProjectsById,
  projectsLoading: false,
  allContourLoading: false,
  projectsByIdLoading: false,
  fetchProjectList: async (params: IParams) => {
    set({ projectsLoading: true });
    const res = await httpApi.get<IPageable<IProjects>>(
      ENDPOINT_PROJECTS_LIST,
      params?.query,
    );
    set({
      projects: res,
    });

    setTimeout(() => {
      set({ projectsLoading: false });
    }, 300);
  },
  fetchProjectById: async (params: { id: string }) => {
    set({ projectsByIdLoading: true });
    const res = await httpApi.get<IProjectsById>(
      ENDPOINT_PROJECTS_LIST + `/${params.id}`,
      {},
    );
    set({
      projectsById: res,
    });

    setTimeout(() => {
      set({ projectsByIdLoading: false });
    }, 300);
  },
  fetchProjectAllContour: async (params: { id: string }) => {
    set({ allContourLoading: true });
    const res = await httpApi.get<IAllContour[]>(
      ENDPOINT_PROJECTS_ALL_CONTOURS + `/${params.id}`,
      {},
    );
    set({
      allContour: res,
    });

    setTimeout(() => {
      set({ allContourLoading: false });
    }, 300);
  },
}));
export default useProjectStore;
